export default {
    methods: {
        hasRole(roles) {
            const rolesToCheck = Array.isArray(roles) ? roles : [roles]
            const rolesFound = rolesToCheck.filter(role => window.Portal.roles.includes(role))

            return rolesFound.length > 0
        },

        canManageCampaigns() {
            return this.hasRole(['advertiser', 'staff']) && this.hasRole(['campaigns'])
        },

        canEditWithSelect(isSelect) {
            return (this.canManageCampaigns() && isSelect === 0) || (this.hasRole('staff') && this.hasRole('campaigns'))
        },

        onlyStaffWithCampaigns() {
            return this.hasRole('staff') && this.hasRole('campaigns')
        },

        hasAdvertiserActive() {
            return Number(window.Portal.advertiserId) > 0
        }
    }
}
